/**
 * Прокрутка плавающей навигации в спецификациях
 */

class SpecsNavigate{

    init(){

        const self = this;

        self.navContainer = document.querySelector('.specs-nav-container');

        self.specsContainer = document.querySelector('.model-specs-container');

        if(self.navContainer){

            const specsBlocks = document.querySelectorAll('.specs-block');
            const specsNavMenu = document.createElement('div');
            specsNavMenu.classList.add('specs-nav-menu');
            self.navContainer.append(specsNavMenu);

            specsBlocks.forEach((block, index) => {

                let section_name = 'section_' + index;
                block.id = section_name;

                let h3 = block.querySelector('h3');
                let text = h3.innerText;

                let element = document.createElement('div');
                element.classList.add('specs-nav-item');
                element.innerText = text;
                element.dataset.section = section_name;

                specsNavMenu.appendChild(element);

            })

            const navItems = self.navContainer.querySelectorAll('.specs-nav-item');

            function activateNavItem() {
                const viewportMiddle = window.scrollY + window.innerHeight / 2; // середина экрана

                let index = specsBlocks.length + 1;

                // Берём последнюю секцию, верх которой уже пересёк середину окна
                while (--index && viewportMiddle < specsBlocks[index - 1].offsetTop) {}

                navItems.forEach(link => link.classList.remove('active'));

                if (index > 0) {
                    navItems[index - 1].classList.add('active');
                }
            }

            function scrollToSection(e){
                e.preventDefault();

                /**
                 * Для того чтобы при клике на панель завигации подсвечивася именно тот пункт по которому кликнули
                 * А не тот который оказался в зоне видимости после анимации скрола
                 * т.к. не все блоки высокие
                 */
                window.removeEventListener('scroll', activateNavItem);

                const targetId = e.target.dataset.section;
                const targetElement = document.getElementById(targetId);
                const offset = targetElement.getBoundingClientRect().top + window.scrollY - 149;

                $('html, body').animate({
                    scrollTop: offset
                }, {
                    duration: 240,   // по умолчанию «400»
                    easing: "linear" // по умолчанию «swing»
                });

                navItems.forEach(link => link.classList.remove('active'));
                e.target.classList.add('active');
                targetElement.querySelector('h3').classList.add('hlight');

                setTimeout(() => {
                    window.addEventListener('scroll', activateNavItem);
                }, 300)

                setTimeout(() => {
                    targetElement.querySelector('h3').classList.remove('hlight');
                }, 1000)


            }

            // для первой загрузки
            activateNavItem();

            window.removeEventListener('scroll', activateNavItem);
            window.addEventListener('scroll', activateNavItem);
            navItems.forEach((link) => link.addEventListener('click', function(e){
                scrollToSection(e);
            }));

        }
    }

}

export default SpecsNavigate;